// Unauthenticated-access guard.
//
// This app has no session of its own: the dashboard (parent window) pushes the
// JWT through postMessage. A user is therefore treated as unauthenticated when
// the app is opened outside the console iframe, or when the console does not
// answer a token request with a well-formed JWT in time — in both cases the
// top window is sent to the console login page.

import {jwtDecode} from "jwt-decode";
import {parentOrigin} from "@/utils/parentOrigin";
import {isLocalDev} from "@/utils/devFunctions";

export const TOKEN_TIMEOUT_MS = 15000

// Disabled on a developer laptop, where the app is often opened standalone.
export const isAuthGuardEnabled = (): boolean => !isLocalDev()

export const isFramed = (): boolean => {
    try {
        return window.self !== window.top
    } catch {
        // cross-origin access to window.top threw: we are framed
        return true
    }
}

export const loginUrl = (): string => `${parentOrigin}/login`

export const redirectToLogin = (): void => {
    const url = loginUrl()
    try {
        if (window.top && window.top !== window.self) window.top.location.href = url
        else window.location.replace(url)
    } catch {
        // browsers block cross-origin top navigation without a user gesture
        window.location.replace(url)
    }
}

// Structural check only — the signature is verified by the API on every call.
export const isWellFormedToken = (token: unknown): token is string => {
    if (typeof token !== "string" || token === "") return false
    try {
        return typeof jwtDecode(token).exp === "number"
    } catch {
        return false
    }
}
